import { isSameDay, addDays, getEasterDate, validateDate, validateYear } from './helpers.js';
import holidayRules from './holidays.js';
export function getHolidaysInYear(year) {
  var yearDate = validateYear(year);
  var yearString = yearDate.getFullYear().toString().padStart(4, '0');
  var yearNumber = parseInt(yearString);
  var easterDate = getEasterDate(yearNumber);
  return holidayRules.map(function (holiday) {
    var date;
    if (holiday.type === 'fixed') {
      date = new Date("".concat(yearString, "-").concat(holiday.date));
    } else {
      date = new Date(addDays(easterDate, holiday.afterEaster));
    }
    var name = holiday.name,
      namePL = holiday.namePL;
    return {
      name: name,
      namePL: namePL,
      date: date
    };
  }).sort(function (a, b) {
    return a.date < b.date ? -1 : 1;
  });
}
export function getHolidayOnDate(dateInput) {
  var date = validateDate(dateInput);
  return getHolidaysInYear(date.getFullYear()).find(function (holiday) {
    return isSameDay(holiday.date, date);
  });
}
export function isHoliday(dateInput) {
  var date = validateDate(dateInput);
  return getHolidayOnDate(date) !== undefined;
}
export function isWeekend(date) {
  return [0, 6].includes(date.getDay());
}
export function isWeekendOrHoliday(date) {
  return isWeekend(date) || isHoliday(date);
}
export function isWorkingDay(date) {
  return !isWeekendOrHoliday(date);
}